import request from '@/utils/request'

import urequest from '@/utils/user.request'
const post = (url: string, data: any) => request({ url, method: 'post', data })
const get = (url: string, data: any) => request({ url, method: 'get', data })

// const upost = (url: string, data: any) => urequest({ url, method: 'post', data })
// 查询工单概况
// @Action({rawError:true})
export const queryWorkOrderList = (data: any) => post('/workOrder/examine/query/summary', data)

// 新签或者续报的工单查看
export const getWorkOrderSign = (data: any) => post('/workOrder/newSellOrder/query/detail', data)

// 查看结课班级工单详情
export const getWorkOrderOver = (data: any) => post('/workOrder/classEnd/query/detail', data)

// 查看异常工单详情
export const getWorkOrderAnomaly = (data: any) => post('/workOrder/anomaly/query/detail', data)

// 查看入班列表
export const getClassList = (data: any) => post('/student/query/summary/by/isGroup', data)

// 查看 班级分配列表
export const getAllocationClassList = (data: any) => post('/class/query/summary/by/director', data)

// 查看 认领列表
export const getAllocationStudentList = (data: any) => post('/student/query/summary/by/director', data)

// 发送的信息列表
export const getSendMessageList = (data: any) => post('/message/external/summary/by/isSended', data)

// 获取模板列表
export const getTemplateList = (data: any) => post('/message/external/template/summary', data)

// 异常审批 列表
export const getAnomalyList = (data: any) => post('/workOrder/submitter/anomaly/query/summary', data)

// 获取审批进度
export const getProgressList = (data: any) => post('/workOrder/submitter/query/summary', data)

// 获取学生通用信息
export const getStudentDetail = (data: any) => post('/student/query/detail/common', data)

// 查询所有班级
export const getAllClass = (data: any) => post('/class/query/summary/name/common', data)

// 转案
export const joinClass = (data: any) => post('/student/relation/create/class', data)

// 获取审批意见
export const getSubmitterNote = (data: any) => post('/workOrder/submitter/query/note', data)

// 收回审批
export const backOrder = (data: any) => post('/workOrder/submitter/edit/site/sketch', data)

// 删除工单
export const deleteOrder = (data: any) => post('/workOrder/submitter/delete', data)

// 认领学员
export const claimStudent = (data: any) => post('/teacher/director/claim', data)

// 新建学员
export const createStudent = (data: any) => post('/workOrder/submitter/create/newStudent', data)

// 查询课程
export const queryCourse = (data: any) => post('/course/query/summary', data)
export const queryCourseB = (data: any) => post('/course/query/summaryB', data)

// 结课审批
export const setWorkOrderStatus = (data: any) => post('/workOrder/examine/edit/status', data)

// 创建异常工单
export const createAnomalyOrder = (data: any) => post('/workOrder/submitter/anomaly/create', data)

// 异常工单静态数据获取
export const getAnomalyStaticData = (data: any) => post('/workOrder/submitter/anomaly/query/static', data)

// 获取异常对象的名称
export const getAnomalyObjectName = (data: any) => post('/workOrder/submitter/anomaly/query/summary/subject', data)

// 获取具体的异常对象的详细信息
export const getAnomalyObjectDetail = (data: any) => post('/workOrder/submitter/anomaly/query/detail/courseInfo', data)

// 通知相关人员
export const noticeAnomalyOrder = (data: any) => post('/message/external/sendForAnomaly', data)

// 新增处理进度
export const addOrderRecord = (data: any) => post('/workOrder/submitter/anomaly/relation/create/note', data)

// 创建模板
export const createTemplate = (data: any) => post('/message/external/template/create', data)

// 获取学生
export const queryStudent = (data: any) => post('/student/query/summary/name', data)

// 更换项目 详情页
export const getChangeCourseOrder = (data: any) => post('/workOrder/changeCourse/query/detail', data)

// 更换导师 详情页
export const getChangeTeacherOrder = (data: any) => post('/workOrder/changeTeacher/query/detail', data)

// 查询所有老师
export const queryAllTeacher = (data: any) => post('/teacher/director/query/summary/common', data)

// 查询所有ta
export const queryAllTa = (data: any) => post('/teacher/TA/query/summary/common', data)

// 给学员分配 老师、ta
export const setTeacherAndTa = (data: any) => post('/class/relation/create/directorTA', data)

// 退项目 详情页
export const queryRefundOrder = (data: any) => post('/workOrder/refund/query/detail', data)

// 重新编辑退项目
export const editSubmitterRefundOrder = (data: any) => post('/workOrder/submitter/edit/refund', data)

// 查看学生详情 带动态的那种
export const getStudentDetailComplex = (data: any) => post('/student/query/detail/complex', data)

// 换项目
export const changeCourse = (data: any) => post('/workOrder/submitter/create/changeCourse', data)

// 修改工单
export const editWorkOrder = (data: any) => post('/workOrder/submitter/edit/newSell', data)

// 换1v1老师
export const changeMainTeacher = (data: any) => post('/workOrder/submitter/create/changeTeacher', data)

// 获取所有主导师
export const queryAllMainTeacher = (data: any) => post('/teacher/master/query/summary/common', data)

// 查询模板
export const queryMessageTemplate = (data: any) => post('/message/external/query/summary/name', data)

// 查询消息班级
export const queryMessageClass = (data: any) => post('/class/query/summary/name/sendMessage', data)

// 查询消息学生
export const queryMessageStudent = (data: any) => post('student/query/summary/name/sendMessage', data)

// 修改模板消息
export const editMessageTemplate = (data: any) => post('/message/external/template/edit', data)

// 是否启用模板
export const setCanUse = (data: any) => post('/message/external/template/edit/canUse', data)

// 续报学生
export const continueJoin = (data: any) => post('/workOrder/submitter/create/continueJoin', data)

// 获取所有课程类型
export const getCourseType = (data: any) => post('/course/query/courseType', data)

// 获取项目时间
export const getCourseTime = (data: any) => post('/course/query/schoolBegins', data)

// 发送消息
export const sendOutMessage = (data: any) => post('/message/external/send', data)

// 新增退项目工单
export const createQuiteProjectOrder = (data: any) => post('/workOrder/submitter/create/refund', data)

// 获取入班前 学生的信息
export const queryStudentDataBeforeEnter = (data: any) => post('/student/query/detail/registGroup', data)

// 班级查询
export const queryClass = (data: any) => post('/class/query/summary/name/all', data)

// 重新续报
export const editContinueJoin = (data: any) => post('/workOrder/submitter/edit/continueJoin', data)

// 重新换项目
export const editChangeCourse = (data: any) => post('/workOrder/submitter/edit/changeCourse', data)

// 重新换导师
export const editChangeTeacher = (data: any) => post('/workOrder/submitter/edit/changeTeacher', data)

// 查看模板详情
export const getTemplateDetail = (data: any) => post('/message/external/template/query/detail', data)

// 检测登录态
export const getUserInfo = (data: any) => post('/user/check', data)

// 注销账号
export const logout = (data: any) => post('/user/logout', data)

// （测试用） 登录
export const login = (data: any) => post('/user/login', data)

// *************************************************************************************************************************
// * 创建班级的反馈
export const createClassFeedback = (data: any) => post('/feedback/create/for/class', data)
// * 创建对学生的反馈
export const createStudentFeedback = (data: any) => post('/feedback/create/for/student', data)
// * 获得对学生反馈的模板
export const queryStudentFeedbackTemp = (data: any) => post('/feedback/query/template/for/student', data)
// * 获得学生反馈的模板（生成学生反馈url
export const queryStudentFeedbackTempUrl = (data: any) => post('/feedback/create/url/for/student', data)
// 查询反馈【新】
export const querySellOrderIdl = (data: any) => post('/evaluation/query/by/sellOrderId', data)
// 修改反馈
export const editNoteSellOrderIdl = (data: any) => post('/evaluation/editNote', data)
// 修改反馈学员
export const editNoteSellOrderIdStudent = (data: any) => post('/evaluation/editNoteForSellOrder', data)
// 项目进度【新】
export const queryEvaluationIdl = (data: any) => post('/evaluation/query/by/classId', data)
// * 导出反馈
export const exportFeedback = (data: any) => post('/feedback/export', data)
// * 获得对学生的反馈详情
export const queryStudentFeedbackDetail = (data: any) => post('/feedback/query/detail/for/student', data)
// * 修改对学生的反馈
export const editFeedback = (data: any) => post('/feedback/edit/for/student', data)
// * 获得某一次班级进度的详情
export const queryClassFeedbackDetail = (data: any) => post('/feedback/query/detail/for/class', data)
// * 推送消息接口
export const sendMessage = (data: any) => post('/wx/sendMessage', data)
// * 获取可推送消息周期
export const getWeekSendMessage = (data: any) => post('/wx/getWeekStr', data)
// * 对某一次班级进度的修改
export const editClassFeedbackDetail = (data: any) => post('/feedback/edit/for/class', data)
// * 【a概况查询】[a-1]（第二期）查询班级列表（结课列表）[mock]
export const queryEndClass = (data: any) => post('/class/query/summary/for/end', data)
// * 查询班级列表
export const queryClassList = (data: any) => post('/class/query/summary/for/normal', data)
// * 查询异常学员概况
export const queryAbnormalStudentsDetail = (data: any) => post('/student/query/summary/by/anomaly', data)
// * 查询异常学员列表
export const queryAbnormalStudentsList = (data: any) => post('/student/query/summary/by/warning', data)
// * 修改学员基本信息
export const editStudentDetail = (data: any) => post('/student/edit', data)
// * 查询班级详情
export const queryClassDetail = (data: any) => post('/class/query/detail', data)
// * 查询班级列表 论文接祖
export const queryClassListPaper = (data: any) => post('/class/query/summary/for/paperGroup', data)
// * 创建mentor
export const createMentorRelation = (data: any) => post('/class/relation/create/mentor', data)
// * 获取mentor
export const getMentorList = (data: any) => post('/teacher/mentor/query/summary/common', data)
// * 创建科研组教
export const createTechnologyTa = (data: any) => post('/class/relation/create/technologyTa', data)
// * 获取科研组教
export const getTechnologyTaList = (data: any) => post('/teacher/technologyTA/query/summary/common', data)
// * 设置主推论文导师/备选论文导师
export const setPaperMasters = (data: any) => post('/class/paper/setPaperMasters', data)
// * 拆组/class/paper/delete/group
export const chaizu = (data: any) => post('/class/paper/delete/group', data)
// * 论文导师
export const getTeacherLunwen = (data: any) => post('/teacher/paperMaster/query/summary/common', data)
// * 获取替换备用导师
export const getReplaceTeacher = (data: any) => post('/teacher/paperMaster/query/summay/by/class', data)
// * 学员列表获取
export const getStudentListByCourseType = (data: any) => post('/student/query/summary/by/courseType', data)
// * 结课申请
export const classOverAction = (data: any) => post('/workOrder/submitter/create/classEnd', data)
// * 设置论文导师
export const setClassLunwenTeacher = (data: any) => post('/class/paper/chooseMaster', data)
// * 获取某一个课程的学生
export const queryPaperGroupStudent = (data: any) => post('/student/query/summary/by/isRegistPaperGroup', data)
// * 设置论文结组
export const makePaperGroup = (data: any) => post('/class/paper/create/group', data)
// * 获取时区信息
export const queryTimeZoom = (data: any) => post('/timetable/query/static/zone', data)
// * 设置课表时查询班级概况
export const queryTummary = (data: any) => post('/timetable/class/query/summary', data)
// * 查询班级时间安排
export const queryClassTimeTummary = (data: any) => post('/timetable/classTimetable/query/summary', data)
// 开课和课表时间
// * 为班级创建课表
export const makeTimetableCreate = (data: any) => post('/timetable/class/create', data)
//  * 修改某个班级某个课表
export const timeTableEdit = (data: any) => post('/timetable/edit', data)
//  * 删除课表
export const deleteTableEdit = (data: any) => post('/timetable/delete', data)
//  * 查询班级时间安排按照周分组
export const querySummaryByWeeks = (data: any) => post('/timetable/query/summary/by/weeks', data)
//  * 第二期）查询班级时间安排按照月分组
export const querySummaryByMonth = (data: any) => post('/timetable/query/summary/by/month', data)
// 强行冲突
export const agreeConflictTimetable = (data: any) => post('/timetable/agreeConflictTimetable', data)
// 结组学员信息查询
export const paperCurrentInfo = (data: any) => post('/class/paper/query/currentInfo', data)
// 修改结组学员
export const editGroup = (data: any) => post('/class/paper/edit/group', data)
// 老师库
// 论文老师库
export const querylwTeacherList = (data: any) => post('/teacher/paperMaster/query/summary/teacherList', data)
// 查看论文老师详情
export const querylwTeacherDetail = (data: any) => post('/class/paper/edit/group', data)
// 论文老师空闲时间
export const querylwTeacherTime = (data: any) => post('/timetable/freeTime/paperMaster/query', data)
// 修改和编辑论文空闲时间
export const editlwTeacherTime = (data: any) => post('/timetable/freeTime/paperMaster/edit', data)
// 获取老师的模版设置
export const queryFreeTimeTemplate = (data: any) => post('/timetable/freeTimeTemplate/paperMaster/query', data)
// 编辑论文模版时间
export const editFreeTimeTemplate = (data: any) => post('/timetable/freeTimeTemplate/paperMaster/edit', data)
// 【三期】
// 论文班级详情
export const queryClassSummary = (data: any) => post('/class/paper/query/summary', data)
// 查询班级论文投递
export const queryClassPaperSend = (data: any) => post('/evaluation/query/paper/by/classId/paperSend', data)
// 班级考勤及作业
export const queryClassPaperEvaluation = (data: any) => post('/evaluation/query/paper/by/sellOrderId', data)
// 班级课程内容
export const queryPaperClassDetail = (data: any) => post('/evaluation/query/paper/by/classId/classDetail', data)
// 修改论文班级评价记录-班级的反馈-课程内容
export const editNoteClassDetail = (data: any) => post('/evaluation/paper/editNote/classDetail', data)
// 修改论文班级评价记录-班级的反馈-论文题投递
export const editNotePaperSend = (data: any) => post('/evaluation/paper/editNote/paperSend', data)
// 修改反馈内容
export const editNoteForSellOrder = (data: any) => post('/evaluation/paper/editNoteForSellOrder', data)
// 微信推送 论文学员信息（课程内容+考勤及作业）
export const sendPaperStudentMessage = (data: any) => post('/wx/paper/student/sendMessage', data)
// 微信推送 班级（课程内容+考勤及作业）
export const sendPaperClassMessage = (data: any) => post('/wx/paper/class/sendMessage', data)
// 获取论文外链链接
export const getUrlpaperMaster = (data: any) => post('/evaluation/getUrl/paperMaster', data)
// 优化部分
// 修改courseCode
export const editCourseCode = (data: any) => post('/class/edit/courseCode', data)
// 更新订单备注
export const editRemark = (data: any) => post('/sellOrder/edit/remark', data)
// 入班班级接口
export const queryforSetClass = (data: any) => post('/class/query/name/forSetClass', data)
// 查询班级管理列表
export const querySummary = (data: any) => post('/classAdmin/query/summary', data)
// 班级管理项目类型
export const querymyCourseType = (data: any) => post('/classAdmin/myCourseType', data)
// 查询班级管理学生列表
export const querySummaryStudent = (data: any) => post('/classAdmin/student/query/summary', data)
// 创建空班级
export const createClass = (data: any) => post('/classAdmin/class/create', data)
// 修改班级
export const editClass = (data: any) => post('/classAdmin/class/edit', data)
// 班级管理调整班级学生
export const editClassStudent = (data: any) => post('/classAdmin/classStudent/edit', data)
// 导出班级现有的学生
export const exportClassStudent = (data: any) => post('/classAdmin/classStudent/export', data)
// 转换班级的时候用于查询可用班级
export const querySummaryClass = (data: any) => post('/classAdmin/className/query', data)
// 删除班级
export const deleteClass = (data: any) => post('/classAdmin/class/delete', data)
// 修改班级详情里面新ta
export const creatCommonTa = (data: any) => post('/class/relation/create/commonTa', data)
// 修改学生详情学生识别号：
export const editIdCard = (data: any) => post('/student/edit/idCard', data)
/// ///////// 首页数据
export const queryHomeLayerData = (data: any) => post('/homeLayer/dataSummary/statistical', data)
// 上课情况
export const queryHomeTimeTable = (data: any) => post('/homeLayer/dataSummary/timeTable', data)
// 人员效能
export const queryHomePersonEfficacy = (data: any) => post('/homeLayer/dataSummary/personEfficacy/bar', data)
// 工作看板-查询
export const queryHomebacklog = (data: any) => post('/homeLayer/query/backlog', data)
// 工作看板-添加
export const createHomebacklog = (data: any) => post('/homeLayer/create/backlog', data)
// 工作看板-修改
export const editHomebacklog = (data: any) => post('/homeLayer/edit/backlog', data)
// 工作看板-删除
export const deleteHomebacklog = (data: any) => post('/homeLayer/delete/backlog', data)
// 工作看板-标记完成
export const finishHomebacklog = (data: any) => post('/homeLayer/finish/backlog', data)
// 信息查看
export const queryHomeinsideMessage = (data: any) => post('/homeLayer/query/insideMessage', data)
// 帮助信息
export const queryHomehelp = (data: any) => post('/homeLayer/query/help', data)
// 消息是否显示
export const checkMessageIsRead = (data: any) => post('/homeLayer/checkMessageIsRead', data)
// 权限配置获取人员
export const queryUsersList = (data: any) => post('/role/queryUsers', data)
// 获取权限
export const queryUsersRole = (data: any) => post('/role/getWorkRole', data)
// 设置权限
export const setUsersRole = (data: any) => post('/role/setWorkRole', data)
// 修改crmID
export const setCrmUserId = (data: any) => post('/role/setCrmUserId', data)
// 放弃论文服务
export const giveUpFreePaperClass = (data: any) => post('/class/freePaperClass/giveUp', data)
// 查询班级详情反馈需要的标签 + 周序号 + 学生
export const queryStaticEvaluationClass = (data: any) => post('/evaluation/commonClass/query/static', data)
// 查询个人反馈
export const queryEvaluationStudent = (data: any) => post('/evaluation/commonClass/query/student', data)
// 查询班级反馈
export const queryEvaluationClass = (data: any) => post('/evaluation/commonClass/query/class', data)
// 修改学生反馈
export const editEvaluationStudent = (data: any) => post('/evaluation/commonClass/edit/student', data)
// 查询班级反馈
export const editEvaluationClass = (data: any) => post('/evaluation/commonClass/edit/class', data)
// 重新上传图片
export const getImageByName = (data: any) => post('/evaluation/getImageByName', data)
// 上传图片报错重新上传
export const getUploadWebError = (data: any) => post('/evaluation/uploadWebError', data)
// IPQ
// 查询ipq班级列表
export const querySummaryIpqList = (data: any) => post('/class/query/summary/for/ipq', data)
// 查询supervisor老师
export const queryIpqSupervisorCommon = (data: any) => post('/teacher/supervisor/query/summary/common', data)
// 设置班级班主任和supervisor
// export const createDirectorSupervisor = (data: any) => post('/class/relation/create/directorSupervisor', data)
// 班级详情设置supervisor
export const createSupervisor = (data: any) => post('/class/relation/create/supervisor', data)
// 【第三期】
// 运营团队列表
export const queryDirectorList = (data: any) => post('teacherAdmin/director/query/summary', data)
// 查看班主任详情
export const queryDirectordetail = (data: any) => post('/teacherAdmin/director/query/detail', data)
// 导师管理-主导师列表查询[暂无]
export const queryTeacherAdmin = (data: any) => post('/teacherAdmin/master/query/summary', data)
// 查询详情-主导师
export const queryTeacherAdminDetail = (data: any) => post('/teacherAdmin/master/query/detail', data)
// 修改主导师评价
export const editAdminDetail = (data: any) => post('/teacherAdmin/master/evaluation/edit', data)
// 导师管理-TA列表查询
export const queryTeacherAdminTA = (data: any) => post('/teacherAdmin/TA/query/summary', data)
// 查询详情-TA
export const queryTeacherAdminTADetail = (data: any) => post('/teacherAdmin/TA/query/detail', data)
// 查询详情-论文导师列表查询
export const queryTeacherAdminpaperMaster = (data: any) => post('/teacherAdmin/paperMaster/query/summary', data)
// 查询详情-论文导师
export const querypaperMaster = (data: any) => post('/teacherAdmin/paperMaster/query/detail', data)
// 修改论文导师数据
export const editpaperMaster = (data: any) => post('/teacherAdmin/paperMaster/edit', data)
// 查询详情-mentor导师列表查询
export const queryTeacherAdminmentor = (data: any) => post('/teacherAdmin/mentor/query/summary', data)
// 创建mentor
export const createMentor = (data: any) => post('/teacherAdmin/mentor/create', data)
// 创建-paperMaster
export const createPaperMaster = (data: any) => post('/teacherAdmin/paperMaster/create', data)
// 创建-supervisor
export const createSupervisorTeacher = (data: any) => post('/teacherAdmin/supervisor/create', data)
// 创建-technologyTA
export const createTechnologyTATeacher = (data: any) => post('/teacherAdmin/technologyTA/create', data)
// 查询详情-mentor
export const queryMentorDetail = (data: any) => post('/teacherAdmin/mentor/query/detail', data)
// 修改-mentor
export const edityMentorDetail = (data: any) => post('/teacherAdmin/mentor/edit', data)
// 查询详情-科研助教导师列表查询
export const queryTeacherAdmintechnologyTA = (data: any) => post('/teacherAdmin/technologyTA/query/summary', data)
// 修改-科研助教导师
export const edittechnologyTADetail = (data: any) => post('/teacherAdmin/technologyTA/edit', data)
// 查询详情-科研助教导师
export const querytechnologyTADetail = (data: any) => post('/teacherAdmin/technologyTA/query/detail', data)
// 查询详情-supervisor导师列表查询
export const queryTeacherAdminsupervisor = (data: any) => post('/teacherAdmin/supervisor/query/summary', data)
// 查询详情-supervisor
export const querySupervisorDetail = (data: any) => post('/teacherAdmin/supervisor/query/detail', data)
// 修改-supervisor
export const editSupervisorDetail = (data: any) => post('/teacherAdmin/supervisor/edit', data)
// 查询ta里面项目详细信息
export const queryTACourseList = (data: any) => post('/teacherAdmin/TACourseList/query/summary', data)
// 创建TA
export const createTA = (data: any) => post('/teacherAdmin/TA/create', data)
// 修改-TA概况
export const editTADetail = (data: any) => post('/teacherAdmin/TA/edit/common', data)
// 修改-TA项目中的薪资
export const editTACourse = (data: any) => post('/teacherAdmin/TA/edit/course', data)
// 修改-TA建议是否续用
export const editTASuggest = (data: any) => post('/teacherAdmin/TA/edit/suggest', data)
// 修改-TA其他
export const editTAOther = (data: any) => post('/teacherAdmin/TA/edit/other', data)
// TA是否离职
export const editTAStatus = (data: any) => post('/teacherAdmin/TA/edit/status', data)
// 论文班级反馈优化
export const evaluationPlanBclassDetail = (data: any) => post('/evaluation/query/paper/planB/by/classId/classDetail', data)
// 论文班级反馈详情
export const evaluationPlanBrandomText = (data: any) => post('/evaluation/query/paperMaster/planB/randomText', data)
// 学生论文反馈详情
export const evaluationPlanBsellOrderId = (data: any) => post('/evaluation/query/paper/planB/by/sellOrderId', data)
// 修改班级反馈
export const editNotePlanBclassDetail = (data: any) => post('/evaluation/paper/planB/editNote/classDetail', data)
// 论文投递
export const paperMasterPlanBCommit = (data: any) => post('/evaluation/query/paperMaster/planB/commit', data)
// ta导师导入
export const TAimport = (data: any) => post('/teacherAdmin/TA/import', data)
// technologyTA导入
export const technologyTAimport = (data: any) => post('/teacherAdmin/technologyTA/import', data)
// supervisor导入
export const supervisorimport = (data: any) => post('/teacherAdmin/supervisor/import', data)
// 论文已结组优化
// 负责人列表接口
export const queryPaperChargeCommon = (data: any) => post('/teacher/paperCharge/query/summary/common', data)
export const setPaperCharge = (data: any) => post('/class/paper/setPaperCharge', data)
// 权限配置修改
export const editEduRoleForPaperChage = (data: any) => post('/role/editEduRoleForPaperChage', data)
// 日志添加记录
export const evaluationExport = (data: any) => post('/evaluation/export', data)
// 日志列表
export const querySummaryeduLogs = (data: any) => post('/eduLogs/querySummary', data)
// 新角色
// 运营主管list
export const queryOperatorMonitorList = (data: any) => post('/role/queryOperatorMonitor', data)
// 修改运营主管与运营专员之间的角色
export const changeWorkRoleForOperator = (data: any) => post('/role/changeWorkRoleForOperator', data)
// 设置运营专员的运营主管
export const setOperatorStaffGroup = (data: any) => post('/role/setOperatorStaffGroup', data)
// 运营主管提交异常给总监
export const submitterAnomalyReport = (data: any) => post('/workOrder/submitter/anomaly/report', data)
// 质检新接口
// 普通班级的班级 1.详情页相关接口
export const inspectorEvaluationSummaryClass = (data: any) => post('/inspector/evaluation/summary/class', data)
//
export const addEvaluationInspector = (data: any) => post('/inspector/evaluation/add', data)
//
export const editEvaluationInspector = (data: any) => post('/inspector/evaluation/edit', data)
// 学员个人的个人项目反馈详情页：学生详情->所报项目信息->反馈详情
export const evaluationSellOrder = (data: any) => post('/inspector/evaluation/summary/sellOrder', data)
//
export const addEvaluationSellOrder = (data: any) => post('/inspector/evaluation/add', data)
//
export const editEvaluationSellOrder = (data: any) => post('/inspector/evaluation/edit', data)
// 班级列表普通班级+一对一
// 给班级设置质检员
export const setEvaluationSellOrder = (data: any) => post('/inspector/set', data)
// /inspector/query
export const queryEvaluationSellOrder = (data: any) => post('/inspector/query', data)
// 【导出PDF】
export const getWeekStrPDF = (data: any) => post('/evaluation/getWeekStrPDF', data)
// 导出接口
export const exportWeekStrPDF = (data: any) => post('/evaluation/exportPDF', data)
// 迭代
export const timeTableCourseType = (data: any) => post('/course/query/timeTableCourseType', data)

// 网申相关字段-按照班级查询
export const queryApplyInfoByClass = (data: any) => post('/sellOrder/query/applyByClass', data)

// 网申相关字段-修改单个订单的网申信息
export const editApplyInfo = (data: any) => post('/sellOrder/edit/apply', data)
// 修改网申资格字段
export const editApplyApplys = (data: any) => post('/sellOrder/edit/applys ', data)

// 网申相关
export const evaluationEmailQuerySellOrder = (data: any) => post('/evaluationEmail/querySellOrder', data)
export const evaluationEmailSendEmail = (data: any) => post('/evaluationEmail/sendEmail', data)
export const evaluationEmailGetEmailDetail = (data: any) => post('/evaluationEmail/getEmailDetail', data)
export const evaluationEmailHistory = (data: any) => post('/evaluationEmail/history', data)
export const evaluationExcelSyncHistory = (data: any) => post('/evaluationExcelSync/queryHistory', data)
// 根据项目id查询自动发送模板名
export const queryAutoSendTemplateByCourseId = (data: any) => post('/message/external/template/queryAutoSendTemplateByCourseId', data)
// 班级推送微信消息
export const goWXSendAccountMessage = (data: any) => post('/wx/WXSendAccountMessage', data)
// 批量入班
export const studentRelationCreateList = (data: any) => post('/student/relation/create/class/list', data)
// 增加/evaluation/lecture/create
export const createLecture = (data: any) => post('/evaluation/lecture/create', data)
// 推送网申消息
export const WXSendAccountMessage = (data: any) => post('/wx/WXSendAccountMessage', data)
// 同步至网申获取学生用户ming
export const insertProjectToApply = (data: any) => post('/class/insertProjectToApply', data)

// 模版新增专业选修课
export const getFoundationCourse = (data: any) => post('/message/external/template/query/foundationCourse', data)

// 获取师资库老师列表
export const getBasicTeacherList = (name: any) => get('/teacher/basic/info/list?name=' + (name || ''), {})

// 获取评价内容
export const getFeedbackGetcontent = (data: any) => post('/evaluationMigrate/feedback/get-content', data)
